module.exports = __webpack_public_path__ + "static/media/tcalliance.6998ea32.png";